/**
 * 위치기반서비스 이용약관 (호주 법률 준수)
 */

import Seo from "@/components/seo/Seo";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock, MapPin, Shield } from "lucide-react";

export default function LocationTerms() {
  return (
    <>
      <Seo
        title="위치기반서비스 이용약관 — OZK News"
        description="OZK News 위치기반서비스 이용약관"
        path="/location-terms"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">위치기반서비스 이용약관</h1>
            <p className="text-lg text-muted-foreground">
              위치 정보의 수집, 이용 및 보호에 관한 약관
            </p>
          </div>

          <Alert className="mb-6">
            <Shield className="h-4 w-4" />
            <AlertDescription>
              본 약관은 호주 개인정보 보호법(Privacy Act 1988) 및 위치정보
              보호법을 준수합니다.
            </AlertDescription>
          </Alert>

          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <MapPin className="w-5 h-5" />
                  위치 정보 수집 및 이용
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  OZK News는 지역별 콘텐츠 제공을 위해 사용자의 위치 정보를
                  수집할 수 있습니다.
                </p>
                <div>
                  <h3 className="font-semibold mb-2">수집 항목</h3>
                  <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                    <li>주소 (시/도, 시/군/구, 동/읍/면)</li>
                    <li>위도 및 경도 좌표 (선택적)</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">이용 목적</h3>
                  <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                    <li>지역별 맞춤 콘텐츠 제공</li>
                    <li>거리 기반 검색 및 필터링</li>
                    <li>지역별 뉴스 및 정보 제공</li>
                  </ul>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Lock className="w-5 h-5" />
                  위치 정보 보호
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  위치 정보는 암호화되어 저장되며, 사용자의 동의 없이 제3자에게
                  제공되지 않습니다.
                </p>
                <p className="text-muted-foreground">
                  사용자는 언제든지 위치 정보 수집 동의를 철회할 수 있으며, 이
                  경우 일부 서비스 이용이 제한될 수 있습니다.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
